import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from '../../common/helpers/history';
import RegularButton from '../../components/RegularButton';
import Illustration from '../../components/Illustration';
import styles from './styles.module.scss';
import { IBindingAction } from '../../common/models/callback';

interface IProps {
  onClick?: IBindingAction;
}

const NotFound: FunctionComponent<IProps> = ({ onClick }) => (
  <div className={styles.wrapper}>
    <Illustration
      variant="map"
      height="70vh"
      header={(
        <FormattedMessage
          id="notFoundPage.label"
          defaultMessage="Hmm... you look a little lost"
        />
      )}
      description={(
        <FormattedMessage
          id="notFoundPage.hint"
          defaultMessage="This page doesn’t exist. Let’s get you back on track."
        />
      )}
      button={(
        <RegularButton
          textIntlId="notFoundPage.button"
          defaultMessage="Let’s go home"
          size="lg"
          onClick={() => (onClick ? onClick() : history.push('/'))}
        />
      )}
    />
  </div>
);

export default NotFound;
